import type { PromptValidationIssue, PromptValidationIssueAction } from '@/components/automations/command-form-types'

const ADD_TOOL_SUGGESTION =
  /add\s+["']([a-z][a-z0-9_]+)["']\s+to\s+(?:the\s+command's\s+allowed\s+tools\s+list|selected_tools?)/i

export function toolActionFromIssue(issue: PromptValidationIssue): PromptValidationIssueAction | null {
  if (issue.action?.type === 'add_tools' && issue.action.tools.length > 0) {
    return { type: 'add_tools', tools: [...new Set(issue.action.tools)] }
  }

  const suggestionMatch = issue.suggestion.match(ADD_TOOL_SUGGESTION)
  if (suggestionMatch) {
    return { type: 'add_tools', tools: [suggestionMatch[1]] }
  }

  if (
    issue.kind === 'missing_tool' &&
    issue.excerpt &&
    /not in selected tools/i.test(issue.message)
  ) {
    return { type: 'add_tools', tools: [issue.excerpt] }
  }

  return null
}

export function mergeToolsIntoSelection(
  current: string[],
  toAdd: string[],
  available: ReadonlySet<string>,
): string[] {
  const next = new Set(current)
  for (const tool of toAdd) {
    if (available.has(tool)) next.add(tool)
  }
  return [...next]
}

export function toolsToAddFromAction(
  action: PromptValidationIssueAction,
  selected: ReadonlySet<string>,
  available: ReadonlySet<string>,
): string[] {
  return action.tools.filter((tool) => available.has(tool) && !selected.has(tool))
}

export function addToolsButtonLabel(tools: string[]): string {
  if (tools.length === 1) return `Add ${tools[0]}`
  return `Add ${tools.length} tools`
}
